// extracted by mini-css-extract-plugin
export default {"caption":"style_caption__yg5gU","icon":"style_icon__gMEf9","dot":"style_dot__AoEIm"};